import { render, staticRenderFns } from "./NewsListComponent.vue?vue&type=template&id=3b1fca87&scoped=true&"
import script from "./NewsListComponent.vue?vue&type=script&lang=js&"
export * from "./NewsListComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewsListComponent.vue?vue&type=style&index=0&id=3b1fca87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1fca87",
  null
  
)

export default component.exports